import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Twitter from '../../components/twitter'

const CustomTableCell = withStyles(theme => ({
    head: {
        textAlign: 'center',
        borderRight: 'medium solid #fff',
        borderLeft: 'medium solid #fff',
        borderWidth: '1px',
        background: '#9A9A9A',
        color: theme.palette.common.white,
        fontSize: 12,
    },
    body: {
        fontSize: 12,
        borderRight: 'medium solid #F0F0F0',
        borderLeft: 'medium solid #F0F0F0',
        borderWidth: '1px',
    },
}))(TableCell);

const styles = (theme) => ({
        root: {
            width: '100%',
            overflowX: 'auto',
        },
        table: {
            minWidth: 700,
        },
        textField: {
            overFlowX: 'hidden',
            marginLeft: theme.spacing.unit,
            marginRight: theme.spacing.unit,
        },
        button: {
            width: '100%'
        },
        cellDiv: {
            width: '100%',
            textAlign: 'center',
            fontSize: 20,
        },
        span: {
            fontSize: 14
        },
        headrow: {
            height: 30
        },
        row: {
            paddingLeft: 0,
            paddingRight: 0,
        },
        sentiment: {
            paddingLeft: 0,
            paddingRight: 0,
        }
    })
;

function CustomizedTable(props) {

    const {classes, comment, type, reply} = props;

    /*
    *  {
            "id": "1000000",
            "screen_name": "XXX XXX",
            "name": "xxx",
            "profile_image_url": "https://xxxxxx",
            "text": "XXX",
            "created_at": "Sat...",
            "reply_text": "XXX",
            "negative": 0.5,
            "positive": 0,
            "reliability": 0.5,
            "bot_replay_flg": true
        }
    *
    * */

    return (
        <Paper className={classes.root}>
            <Table className={classes.table}>
                <TableHead className={classes.head}>
                    <TableRow className={classes.headrow}>
                        {props.head.map((row, index) => {
                            return (
                                <CustomTableCell width={row.width} height={30}
                                                 key={index}>{row.name}</CustomTableCell>
                            )
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.data && props.data.map((row, index) => {
                            return (
                                <TableRow key={index} className={classes.row}>
                                    <CustomTableCell
                                        className={[classes.sentiment,  row.reply_text ? "" : type]}>
                                        <div className={classes.cellDiv}>
                                            <span className={classes.span}>
                                                {row.negative > 0 ? "NEGATIVE" : (row.positive > 0 ? "POSITIVE" : "")}
                                            </span>
                                        </div>
                                        <div className={classes.cellDiv}>
                                            {row.negative > 0 ? parseInt(row.negative * 100) : (row.positive > 0 ? parseInt(row.positive * 100) : "")}
                                            <span className={classes.span}>%
                                            </span>
                                        </div>
                                        <div className={classes.cellDiv}>
                                            <span className={classes.span}>
                                                {(row.reliability > 60 ? '★★★' : (
                                                    (row.reliability > 30) ? '★★' : (
                                                        (row.reliability >= 0) ? '★' : ''
                                                    )
                                                ))}
                                            </span>
                                        </div>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Twitter
                                            name={row.name}
                                            screen_name={row.screen_name}
                                            profile_image_url={row.profile_image_url}
                                            text={row.text}
                                            created_at={row.created_at}
                                            reply_text={row.reply_text}
                                            negative={row.negative}
                                            positive={row.positive}
                                            reliability={row.reliability}
                                            bot_replay_flg={row.bot_replay_flg}
                                        />
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        {!row.reply_text && !row.replied && (
                                            <TextField
                                                multiline
                                                label="Comment"
                                                value={row.comment}
                                                onChange={e => comment(type, row.id, e.target.value)}
                                                className={classes.textField}
                                                margin="normal"
                                                variant="outlined"
                                            />
                                        )}
                                        <Button variant="contained" className={[classes.button, row.reply_text ? "" : type]}
                                                color={row.reply_text ? (row.bot_replay_flg ? 'default' : 'secondary') : ""}
                                                onClick={() => !row.reply_text ? reply(type, row.id, row.user_id, row.comment) : null}
                                        >
                                            {row.reply_text ? (row.bot_replay_flg ? 'REPLIED' : 'AUTO REPLIED') : (row.replied ? "REPLIED" : "REPLY")}
                                        </Button>
                                    </CustomTableCell>
                                </TableRow>
                            );
                        })
                    }
                </TableBody>
            </Table>
        </Paper>
    );
}


export default withStyles(styles)(CustomizedTable);
